<template>
  <div class="h-search-vue">
    <div :class="this.container_css_classLocal" id="search-input-container">
      <input type="text"
             name="q"
             autocomplete="off"
             autocorrect="off"
             autocapitalize="off"
             spellcheck="false"
             :class="this.input_css_classLocal"
             id="search-input-vue"
             ref="search-input-vue"
             v-model="q_param"
             v-on:input="debounceInput"
             @focus="doStart"
             @keyup.enter="onSearch"
             :placeholder="this.input_placeholderLocal"
      />
      <button id="do-search" :class="this.button_css_classLocal" @click.prevent="onSearch">
        <slot>
          <svg class="h-search__btn-icon" width="15" height="15">
            <use xlink:href="#icon-search"></use>
          </svg>
        </slot>
      </button>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import _ from 'lodash'


export default {
name: "sm-search-button",
  props: {
    container_css_class: {
      type: String,
      default: "h-search__form-group",
    },
    input_css_class: {
      type: String,
      default: "h-search__input form-control",
    },
    input_placeholder: {
      type: String,
      default: "",
    },
    button_css_class: {
      type: String,
      default: "h-search__btn"
    }
  },
  data() {
    return {
      container_css_classLocal: this.container_css_class,
      input_css_classLocal: this.input_css_class,
      input_placeholderLocal: this.input_placeholder,
      button_css_classLocal: this.button_css_class
    }
  },
  computed: {
    ...mapGetters("search",['q', 'isAutocompleteMode', "isMobile", "redirectUrl"]),
    q_param: {
      get: function () {
        return this.q;
      },
      set: function (value) {
        this.setQString(value);
      }
    }
  },
  methods: {
    ...mapActions("search", [
      "setAutocompleteMode",
      "setSearchMode",
      "setStart",
      "autocomplete",
      "addToHistory",
      "doSearch",
      "setQString",
      "setCorrectPosition",
      "selectCategory",
      "resetFilters",
      "setBodyClasses",
      "clearAutocomplete"
    ]),
    doStart() {
      this.setCorrectPosition();
      if(!this.isAutocompleteMode) {
        this.clearAutocomplete();
        this.setStart().then(() => {
          this.setAutocompleteMode();
          this.setBodyClasses();
          this.$refs['search-input-vue'].focus();
        }).catch(err => {
          console.log(err)
        })
      }
    },
    onSearch() {
      if(this.q.length === 0) {
        return;
      }
      // пишем q в localStorage
      this.addToHistory()
      this.selectCategory(0)
      this.resetFilters()
      // выполняем поиск
      this.doSearch().then(() => {
        if(this.redirectUrl.length) {
          window.location.href = this.redirectUrl
        } else {
          // переключаем на страницу результатов
          this.setSearchMode();
          // убираем фокус с инпута
          this.$refs['search-input-vue'].blur();
        }
      }).catch(err => {
        console.log(err.response.statusText)
      })
    },
    debounceInput: _.debounce(function () {
      this.autocomplete(this.q_param)
          .catch(err => {
            console.log(err)
          })
    }, 500)
  }
}
</script>

<style>
.sm-disable-scroll {
  overflow: hidden !important;
}
.sm-body_mobile.sm-disable-scroll {
  position: fixed !important;
}
body.sm-disable-scroll:not(.sm-body_mobile) {
  position: fixed !important;
  width: 100%;
  overflow-y: scroll !important;
  padding-right: 0 !important;
}
.sm-disable-scroll #cities-select-container-overlay {
  z-index: 9999999;
}
.sm-disable-scroll #cities-select-container,
.sm-disable-scroll .arcticmodal-container,
.sm-disable-scroll .arcticmodal-overlay,
.sm-disable-scroll .dropdown-menu.show {
  z-index: 99999999;
}
body.sm-disable-scroll .header {
  border-color: #fff;
}
</style>